/** Client mirror of server library freshness mapping (render-only; prefer payload.freshness). */

export type FreshnessBand = "fresh" | "aging" | "stale" | "unknown";

const STALE_THRESHOLD_DAYS: Record<string, number> = {
  architecture: 90,
  runbook: 180,
  "how-to": 90,
};

function freshnessTypeForDoc(docType: string): string {
  if (docType === "runbook") return "runbook";
  if (docType === "overview") return "architecture";
  return "how-to";
}

export function freshnessBand(verifiedAt: string | undefined, docType: string, now = new Date()): FreshnessBand {
  if (!verifiedAt) return "unknown";
  const verified = Date.parse(`${verifiedAt}T00:00:00Z`);
  if (Number.isNaN(verified)) return "unknown";
  const thoughtType = freshnessTypeForDoc(docType);
  const threshold = STALE_THRESHOLD_DAYS[thoughtType] ?? 90;
  const ageDays = (now.getTime() - verified) / (24 * 3600 * 1000);
  if (ageDays >= threshold) return "stale";
  if (ageDays >= threshold / 2) return "aging";
  return "fresh";
}

export function freshnessLabel(band: FreshnessBand, verifiedAt?: string): string {
  if (!verifiedAt) return "unverified";
  const ageDays = Math.floor((Date.now() - Date.parse(`${verifiedAt}T00:00:00Z`)) / 86400000);
  if (band === "stale") {
    const months = Math.max(1, Math.round(ageDays / 30));
    return `verify: ${months} month${months === 1 ? "" : "s"} ago`;
  }
  if (band === "aging") return `verified ${ageDays}d ago`;
  if (band === "fresh") return `verified ${ageDays === 0 ? "today" : `${ageDays}d ago`}`;
  return "unverified";
}
